var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1539_61450)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5.5873V58.4127C16 61.4985 18.4624 64 21.5 64H58.5C61.5376 64 64 61.4985 64 58.4127V14.7025C64 13.21 63.4122 11.7796 62.3677 10.7301L53.2957 1.61483C52.266 0.58026 50.8762 0 49.428 0H21.5C18.4624 0 16 2.50152 16 5.5873ZM19.5 58.4127V5.5873C19.5 4.4652 20.3954 3.55556 21.5 3.55556H48.75V15.746C48.75 17.85 50.4289 19.5556 52.5 19.5556H60.5V58.4127C60.5 59.5348 59.6046 60.4444 58.5 60.4444H21.5C20.3954 60.4444 19.5 59.5348 19.5 58.4127ZM60.5 16V14.7025C60.5 14.1598 60.2863 13.6396 59.9064 13.258L52.25 5.56509V15.746C52.25 15.8863 52.3619 16 52.5 16H60.5Z",
    fill: "#9D9C9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 26.25C41 25.2835 41.7835 24.5 42.75 24.5H54.25C55.2165 24.5 56 25.2835 56 26.25C56 27.2165 55.2165 28 54.25 28H42.75C41.7835 28 41 27.2165 41 26.25Z",
    fill: "#6BB3EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 34.25C41 33.2835 41.7835 32.5 42.75 32.5H54.25C55.2165 32.5 56 33.2835 56 34.25C56 35.2165 55.2165 36 54.25 36H42.75C41.7835 36 41 35.2165 41 34.25Z",
    fill: "#508FD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 42.25C41 41.2835 41.7835 40.5 42.75 40.5H54.25C55.2165 40.5 56 41.2835 56 42.25C56 43.2165 55.2165 44 54.25 44H42.75C41.7835 44 41 43.2165 41 42.25Z",
    fill: "#3770C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.5C0 16.8431 1.34315 15.5 3 15.5H33C34.6569 15.5 36 16.8431 36 18.5V48.5C36 50.1569 34.6569 51.5 33 51.5H3C1.34315 51.5 0 50.1569 0 48.5V18.5Z",
    fill: "#3770C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9238 43.043L7 23H10.4043L12.8652 36.7676L15.873 23H19.8242L22.709 37L25.2383 23H28.5742L24.582 43.043H21.0547L17.7734 28.0586L14.5195 43.043H10.9238Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1539_61450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.5f31f3703f2dcef26a57bf81b5b3ceff.svg";
export { ForwardRef as ReactComponent };